import React from 'react';
import DragAnchor from "./DragAnchor";
import PropTypes from "prop-types";

class DesktopInteractivePlayerContainer extends React.Component {
  static defaultProps = {
    updatePlaceholder: () => {}
  }

  constructor(props) {
    super(props);
    this.state = {
      top: undefined,
      left: undefined,
      transitioning: false,
      poppedOut: false,
    }
  }

  playerTransitionStyle = () => {
    const showPlaceholder = this.state.poppedOut || this.state.transitioning;
    const style = {
      zIndex: 1000,
      transition: 'right 0.3s ease-in-out',
    };

    style.minWidth = 320;

    if (showPlaceholder) {
      style.position = 'fixed';
      style.width = '25vw';
      style.top = this.state.top;
    }

    if (this.state.poppedOut) {
      style.left = this.state.left
      style.right = !this.state.left ? 10 : 300;
    } else {
      style.right = -400;
    }

    style.bottom = !this.state.top && 10;

    return style;
  }

  onDrag = (x, y) => {
    this.setState({
      left: x,
      top: y
    })
  }

  setPopOutState(isPoppedOut) {
    if (isPoppedOut) {
      this.props.updatePlaceholder(true);
    }

    if (this.state.poppedOut !== isPoppedOut) {
      this.setState({
        transitioning: true,
        poppedOut: isPoppedOut
      });


      return this.resetTransitioning();
    }
  }

  resetTransitioning = () => {
    return new Promise(resolve => {
      setTimeout(() => {
        if (!this.state.poppedOut) {
          this.props.updatePlaceholder(false);
        }

        this.setState({
          transitioning: false
        }, resolve)
      }, 300);
    })
  }

  popOutPlayerMenu() {
    if (!this.state.poppedOut) {
      return null;
    }

    return (
      <React.Fragment>
        <img onClick={this.props.dismissPlayer} className="dismiss-button" src="/img/icons/ooyala/close-icon.svg" />
        <DragAnchor
          onDrag={this.onDrag}
          getDraggedRect={() => this.container.getBoundingClientRect()}
        />
      </React.Fragment>
    )
  }

  resetPopOutPosition() {
    if (this.state.poppedOut || this.state.transitioning) {
      return
    }

    if (!this.state.top || !this.state.left) {
      return
    }

    this.setState({
      top: undefined,
      left: undefined,
    })
  }

  setContainerReference = (ref) => {
    this.container = ref;
  }

  render() {
    this.resetPopOutPosition();

    return (
      <div
        ref={this.setContainerReference}
        className="transitionPosition spl-interactive-video-player"
        style={this.playerTransitionStyle()}
      >
        {this.popOutPlayerMenu()}
        {this.props.children}
      </div>
    )
  }
}

DesktopInteractivePlayerContainer.propTypes = {
  player: PropTypes.shape({
    play: PropTypes.func,
    pause: PropTypes.func
  }),
  children: PropTypes.any,
  updatePlaceholder: PropTypes.func,
  dismissPlayer: PropTypes.func
}

export default DesktopInteractivePlayerContainer;



// WEBPACK FOOTER //
// ./modules/Ooyala/component/DesktopInteractivePlayerContainer.js